import { IconName } from './Icon.types';

/** Константа для суффикса анимированных иконок */
export const ANIMATED_ICON_SUFFIX = 'Animated';

/** Хелпер для проверки, является ли иконка анимированной */
export const isAnimatedIcon = (iconName: IconName): boolean => {
    return iconName.endsWith(ANIMATED_ICON_SUFFIX);
};

/**
 * Получает базовое имя иконки без суффикса "Animated"
 * @param iconName - имя иконки (может быть с суффиксом "Animated")
 * @returns базовое имя иконки
 * @example
 * getBaseIconName('competeAnimated') // 'compete'
 * getBaseIconName('compete') // 'compete'
 */
export const getBaseIconName = (iconName: IconName): IconName => {
    if (isAnimatedIcon(iconName)) {
        return iconName.slice(0, -ANIMATED_ICON_SUFFIX.length) as IconName;
    }

    return iconName;
};
